<template>
  <div>
    <Header />
    <div>
        <span class="navTitle">
        <span class="exhibitTitle">Modifier une ressource</span>
        <br>
        <q-btn color="pink-10" style="margin-left:7%" @click="navigateToExpo">Retour</q-btn>
        </span>
      <hr style="margin-bottom: 15px; margin-top: 15px;">

      <q-form class="form">
        <q-input
          v-model="name"
          outlined
          label="Nom"
          required
        ></q-input>
         <q-input
         outlined
          v-model="title"
          label="Titre"
          required
        ></q-input>
        <q-input outlined type="textarea" label="Description" v-model="description"></q-input>
        <input
        outlined
          type="file"
          label="Fichier"
          id="file"
          ref="file"
          @change="selectFile"
        />
      </q-form>
      <q-btn
        style="margin-left: 20%; margin-top: 20px"
        color="secondary"
        class="send"
        @click="send()"
        >Envoyer</q-btn
      >

      <div class='alert' dense text type="success" v-show="this.success">
        Enregistré
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
export default {
  components: {
    Header
  },
  props: ["id", "ancientResourceName"],
  data() {
    return {
      file: null,
      name: "",
      success: false,
      description: "",
      title: "",
      resource_id: ""
    };
  },
  methods: {
    navigateToExpo(){
      this.$router.go(-1)
    },
    selectFile(event) {
      this.file = event.target.files[0];
      if (event.target.files.length != 0)
        this.name = event.target.files[0].name;
    },
    async send() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resourceData`;
        let response = await axios.put(url, {
          method: "put",
          data: {
            name: this.name,
            resourceId: this.resource_id,
            description: this.description,
            title: this.title,
            ancientName : this.ancientResourceName,
          },
        });
        if (response.status == 200) {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 1500);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        let formData = new FormData();
        formData.append("file", this.file);
        let url = `${process.env.VUE_APP_BASEURL}/file`;
        let response = await axios.post(url, formData);
        if (response.status == 200) {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 1500);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  async created(){
      try {
        this.resource_id = this.$route.params.resource_id;
        let url = `${process.env.VUE_APP_BASEURL}/resourceData/${this.resource_id}`;
        let response = await axios.get(url);
        this.title = response.data[0].title;
        this.description = response.data[0].description;
        this.name = response.data[0].name;
      } catch (error) {
        console.log(error);
      }
  }
};
</script>

<style>
.form {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: auto;
}
</style>